export const scoreConfig_AllergyandEczema_9P = [
    {
        titel: `Eczema`,
        match_key: 'Eczema',
        Xdotpos: 177,
        Ydotpos: 920,
        Xnumberpos: 580,
        Ynumberpos: 895,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 1,
        value_use: [
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus acidophilus',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Allergic rhinitis`,
        match_key: 'Allergic rhinitis',
        Xdotpos: 177,
        Ydotpos: 1025,
        Xnumberpos: 580,
        Ynumberpos: 1000,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 5,
        value_use: [
            'Bifidobacterium breve',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Overweight`,
        match_key: 'Overweight',
        Xdotpos: 177,
        Ydotpos: 275,
        Xnumberpos: 580,
        Ynumberpos: 250,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 5,
        value_use: [
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus gasseri',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Constipation`,
        match_key: 'Constipation',
        Xdotpos: 177,
        Ydotpos: 568,
        Xnumberpos: 580,
        Ynumberpos: 541,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 5,
        value_use: [
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: ['Metabolic', 'syndrome'],
        match_key: 'Metabolic syndrome',
        Xdotpos: 177,
        Ydotpos: 385,
        Xnumberpos: 580,
        Ynumberpos: 360,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 4,
        value_use: [
            'Bifidobacterium lactis',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `['Excessive', 'lipopolysaccharide']`,
        match_key: 'Excessive lipopolysaccharide',
        Xdotpos: 177,
        Ydotpos: 610,
        Xnumberpos: 580,
        Ynumberpos: 582,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 4,
        value_use: [
            'Bifidobacterium bifidum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `['Insomnia/ poor', 'sleep quality']`,
        match_key: 'Insomnia/ poor sleep quality',
        Xdotpos: 177,
        Ydotpos: 830,
        Xnumberpos: 580,
        Ynumberpos: 805,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 4,
        value_use: [
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `['Stress and', 'anxiety']`,
        match_key: 'Stress and anxiety',
        Xdotpos: 177,
        Ydotpos: 947,
        Xnumberpos: 580,
        Ynumberpos: 920,
        formula: 'static_asthma_score',
        max_dot: 10,
        dot_show: false,
        number_show: false,
        // page: 5,
        value_use: [
            'Bifidobacterium bifidum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    }
]

// Export bacteria type configuration for 9P format
export const typeofbacteria_9P = {
  core_bacteria: [
    'Akkermansia muciniphila',
    'Alistipes putredinis',
    'Bacteroidetes phylum',
    'Bacteroides genus',
    'Bacteroides fragilis',
    'Faecalibacterium prausnitzii',
    'Roseburia hominis'
  ],
  harmful_bacteria: [
    'Bacillus genus',
    'Candida albicans',
    'Clostridium difficile',
    'Escherichia coli',
    'Staphylococcus aureus'
  ],
  beneficial_bacteria: [
    'Bifidobacterium bifidum',
    'Bifidobacterium breve',
    'Bifidobacterium lactis',
    'Bifidobacterium longum',
    'Lactobacillus acidophilus',
    'Lactobacillus gasseri',
    'Lactobacillus helveticus',
    'Lactobacillus paracasei',
    'Lactobacillus plantarum',
    'Lactobacillus reuteri',
    'Lactobacillus rhamnosus',
    'Streptococcus thermophilus'
  ]
};
